import { createFileRoute } from '@tanstack/react-router';

import NpsCampaigns from '@/modules/nps/pages/Campaigns';

export const Route = createFileRoute('/_authenticated/_system/_tenant/nps/')({
  head: () => ({
    meta: [{ title: 'NPS' }],
  }),
  component: NpsCampaigns,
});
